import * as React from 'react';
import { useEffect, useState } from 'react';
import { Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from 'react-redux';
import EditTask from './components/editTask';
import Task from './components/Task';
import { getProjectTasks, loadProjectTasks, loadTask } from './tasksSlice';
import isEmpty from '../../functions/functions';

const Tasks = (props) => {
    const dispatch = useDispatch();
    var tasksList = useSelector(loadProjectTasks);
    var task = useSelector(loadTask);
    const [resList, setList] = useState([]);

    useEffect(() => {
        dispatch(getProjectTasks(props.projectGuid));

    }, []);

    useEffect(() => {
        var index = tasksList?.findIndex(t => t.projectGuid == props.projectGuid);
        setList(index >= 0 ? [...[...tasksList[index].tasksList].filter(x => x.status == 3), ...tasksList[index].tasksList.filter(x => x.status != 3).sort((a, b) => a.status - b.status)] : null);
    }, [tasksList]);

    useEffect(() => {
        if (task.projectGuid == props.projectGuid && !isEmpty(resList)) {
            var index = resList?.findIndex(t => t.projectGuid == props.projectGuid);
            var temp = [...resList.map(x => x.guid == task.guid ? { ...x, status: task.status } : x)];
            setList(index >= 0 ? [...temp.filter(x => x.status == 3), ...temp.filter(x => x.status != 3).sort((a, b) => a.status - b.status)] : null);
        }
    }, [task]);
    //var index = tasksList?.findIndex(t => t.projectGuid == props.projectGuid);
    //setList(index >= 0 ? [...[...resList[index].tasksList].filter(x => x.status == 3), ...resList[index].tasksList.filter(x => x.status != 3).sort((a, b) => a.status - b.status)]: null);
        //tasksList.length >= 0 && tasksList.findIndex(t => t.projectGuid == props.projectGuid) ?
        //tasksList[tasksList.findIndex(t => t.projectGuid == props.projectGuid)].tasksList : null;
  
    return (
        <div className="project-tasks-list">
            <EditTask task={{ projectGuid: props.projectGuid }}  />
            <div id={props.projectGuid} className="project-task-list">
                <div>
                    <ul key={"ul_" + props.projectGuid} id={"ul_" + props.projectGuid} className="task-list task-sortable">
                        <Droppable droppableId={props.projectGuid} >
                            {(provided, snapshot) => (
                                <div className="droppable-tasks"
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {resList && resList.map((task, index) => (
                                        <Draggable key={task.guid} draggableId={task.guid} index={index} >
                                            {(provided, snapshot) => (
                                                <div className="draggable-free"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <Task key={"task_" + task.guid} task={task} />
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Tasks;